import { render } from "./CustomerProfile.vue?vue&type=template&id=78ee027a"
import script from "./CustomerProfile.vue?vue&type=script&lang=js"
export * from "./CustomerProfile.vue?vue&type=script&lang=js"

import "./CustomerProfile.vue?vue&type=style&index=0&id=78ee027a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__